import ScrollReveal from 'scrollreveal';

export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    const sr = ScrollReveal({
      distance: '30px',
      duration: 800,
      easing: 'ease-out',
      reset: false,
      viewFactor: 0.2,
    });

    // Mobile hero (visible on load – viewFactor 0)
    sr.reveal('.mobile-hero .cta-box-small .value-1', { origin: 'top', delay: 150, viewFactor: 0 });
    sr.reveal('.mobile-hero .cta-box-small .value-2', { origin: 'top', delay: 250, viewFactor: 0 });
    sr.reveal('.mobile-hero .hero-figma__btn--primary', { origin: 'bottom', delay: 300, viewFactor: 0 });
    sr.reveal('.mobile-hero .hero-figma__btn--secondary', { origin: 'bottom', delay: 150, viewFactor: 0 });

    // Footer hero (scroll-in section with .section.hero-figma)
    sr.reveal('.hero-figma .hero-figma__inner', { origin: 'bottom', delay: 100 });
    sr.reveal('.hero-figma .hero-figma__title', { origin: 'top', delay: 200 });
    sr.reveal('.hero-figma .hero-figma__desc', { origin: 'top', delay: 280 });
    sr.reveal('.hero-figma .hero-figma__btn--primary', { origin: 'bottom', delay: 360 });
    sr.reveal('.hero-figma .hero-figma__btn--secondary', { origin: 'bottom', delay: 440 });

    // Features section
    sr.reveal('.section-features .card-feature', { origin: 'bottom', interval: 400 });

    // Why choose (both use .section-why-choose + .card-feature)
    sr.reveal('.section-why-choose .section-head', { origin: 'top', delay: 100 });
    sr.reveal('.section-why-choose .card-feature', { origin: 'bottom', interval: 150 });
    sr.reveal('.section-why-choose .btn', { origin: 'bottom', interval: 280 });

    // Service sections (repeated blocks) – image origin by row layout
    sr.reveal('.section-service .section-title', { origin: 'top', delay: 100 });
    sr.reveal('.section-service__row--image-left .section-service__image-wrap', { origin: 'left', delay: 150 });
    sr.reveal('.section-service__row--image-right .section-service__image-wrap', { origin: 'right', delay: 150 });
    sr.reveal('.section-service__row--image-left .section-service__content', { origin: 'right', delay: 150 });
    sr.reveal('.section-service__row--image-right .section-service__content', { origin: 'left', delay: 200 });
    sr.reveal('.section-service .section-service__content .hero-figma__btn', { origin: 'bottom', delay: 220 });
    sr.reveal('.section-service .card-service', { origin: 'bottom', interval: 250 });

    //industries section
    sr.reveal('.section-industries .section-title', { origin: 'top', delay: 200 });
    sr.reveal('.section-industries .card-feature', { origin: 'bottom', interval: 250 });

    // Featured listings — deferred until after common.finalize inits Slick (Router order)
    if (document.querySelector('.section-listings')) {
      setTimeout(() => {
        const listingsMobile = window.matchMedia('(max-width: 767px)').matches;

        sr.reveal('.section-listings .section-head', { origin: 'top', delay: 100 });
        sr.reveal('.section-listings .section-listings__image-col', {
          origin: listingsMobile ? 'bottom' : 'left',
          delay: 150,
        });
        // Avoid transforms on the Slick root; animate the content wrapper instead.
        sr.reveal('.section-listings .section-content-wrap', {
          origin: listingsMobile ? 'bottom' : 'right',
          delay: 200,
        });
        sr.reveal('.section-listings .section-listings__slider-row', { origin: 'bottom', delay: 220 });
      }, 0);
    }

    // Testimonials section
    sr.reveal('.testimonials-panel .section-title', { origin: 'top', delay: 150 });
    sr.reveal('.testimonials-panel .testimonials-img-col', { origin: 'left', delay: 150 });
    sr.reveal('.testimonials-panel .testimonials', { origin: 'bottom', delay: 200 });

    // FAQ section
    sr.reveal('.faqs-panel .section-title', { origin: 'top', delay: 100 });
    sr.reveal('.faqs-panel .accordion-item', {
      origin: 'bottom',
      delay: (el) => {
        const items = document.querySelectorAll('.faqs-panel .accordion-item');
        return Array.from(items).indexOf(el) * 80;
      },
      interval: 50,
    });
    sr.reveal('.faqs-panel .text-center .btn', { origin: 'bottom', delay: 200 });


  },
};
